<template>
  <el-row class="kmos-step">
      <el-steps direction="vertical" :active="stepIndex" finish-status="success" process-status="process" space="auto">
          <el-step :title="item.title" :class="{disabled: getDisabled(item), allowClick: !getDisabled(item)}" v-for="(item,index) in stepsObj" @click.native="navStepClick(item)" :key="index">
              <i slot="description" class="step-icon" :class="item.name"></i>
          </el-step>
      </el-steps>
  </el-row>
</template>

<script>
export default {
  data () {
    return {
      stepIndex: 0,
      stepsObj: [],
      bizFlowStepsObj: {
        baseInfoNode: "资料录入",
        acctInfoNode: "账户资料",
        acctPwdInfoNode: "账户密码设置",
        permInfoNode: "权限资料",
        creditRatingNode: "评级授信",
        creditInvestNode: "征信资料",
        orgPartner: "信息录入",
        bizInfoNode: "资料录入",
        evaluatingNode: "知识测评",
        bizConfirm: "业务确认",
        custVisitNode:"客户回访",
        openAcctInfoNode: "开户信息",
        agentInfoNode: "经办人信息",
        keyInfoNode: "关键信息变更",
        normalInfoNode: "非关键信息变更",
        videoWitnessInfoNode:"见证双录",
        formPrintNode: "表单打印",
        custMatchResultNode:"适当性信息",
        formUploadNode:"上传表单",
        imageUploadNode:"影像上传"
      },
      otherStepsObj: {
        imageCollectSupply: "资料采集",
        imageAcquisition: "影像采集",
      }
    };
  },
  mounted () {
    this.initSteps();
  },
  activated () {
    this.initSteps();
  },
  deactivated () {
    this.$destroy();
  },
  computed: {
    navTitle () {
      if (this.$route.path.split("/")[1] == "bizFlow" || this.$route.path.split("/")[1] == "imageAcquisition" ) {
        let stepVal = this.$route.path.split("/")[4];
        let routeName = this.bizFlowStepsObj[stepVal] || "";
        return routeName;
      } else {
        return this.$route.meta.name;
      }
    },
    navRouteTable () {
      let navs = [];
      _.each(this.bizRouteTable, (route) => {
        let nodeId = route.path.split("/")[4];
        if(nodeId && this.bizFlowStepsObj[nodeId] && route.show){
          navs.push(this.bizFlowStepsObj[nodeId]);
        }
        // 影像节点特殊处理，否则左侧不展示影像节点
        if(route.name == "影像采集"){
          navs.push("影像采集");
        }
      });
      return _.uniq(navs);
    },
    isRightShow () {
      return "rightOptions" in this.$route.meta;
    },
    maxItem () {
      // return this.isRightShow ? 7 : 7;
      return 10;
    },
    bizRouteTable () {
      return this.$store.state.bizRouteTable;
    },
    disableNavStep () {
      return this.$store.state.disableNavStep;
    },
    busiInfo () {
      return this.$storage.getJsonSession(this.$definecfg.BUSI_INFO) || {};
    },
    apptStatus () {
      return this.$store.state.apptStatus;
    },
    busiCode () {
      return this.$store.state.busicode;
    },
    oldBizData (){
      return this.$store.state.oldBizData;
    }
  },
  watch: {
    navRouteTable () {
      this.initSteps();
    },
    navTitle () {
      this.initSteps();
    },
    maxItem () {
      this.initSteps();
    },
  },
  methods: {
    initSteps () {
      if (this.navRouteTable && this.navRouteTable.indexOf(this.navTitle) >= 0) {
        let steps = this.navRouteTable;
        let currentSIdx = steps.indexOf(this.navTitle);
        if (steps.length > this.maxItem) { // 超过maxItem个节点自动划分为5节点
          let startIdx = _.min([_.max([0, currentSIdx - 2]), steps.length - this.maxItem]);
          steps = steps.slice(startIdx, startIdx + this.maxItem);
          currentSIdx = steps.indexOf(this.navTitle);
        }

        this.stepIndex = currentSIdx;
        this.stepsObj = this.assembleSteps(steps);


      }
    },
    assembleSteps (steps) {
      let stepsArr = Object.entries(Object.assign({}, this.bizFlowStepsObj, this.otherStepsObj));
      return steps.reduce((acc, title) =>  {
        let step = _.find(stepsArr, ([key, val]) => {
          return val === title;
        }) || [];
        if (step.length) {
          acc.push({
            name: step[0],
            title: step[1]
          });
        }
        return acc;
      }, []);
    },
    navStepClick (item) {
      if (this.disableNavStep || this.getDisabled(item)) {
        return;
      }
      let index = this.navRouteTable.indexOf(item.title);
      let currentIndex = this.navRouteTable.indexOf(this.stepsObj[this.stepIndex].title);
      // 预约状态为已完成的不限制
      let isFinish = this.$syscfg.consts().FINISH_APPT_STATUS.includes(this.apptStatus);
      //todo test 放开限制都允许跳转
      // currentIndex=999;
      if (index < currentIndex || !!isFinish) {
        switch (this.navRouteTable[index]) {
          case "客户资料":
          case "资料录入":
            this.goToRouter("baseInfoNode");
            break;
          case "账户资料":
            this.goToRouter("acctInfoNode");
            break;
          case "账户密码设置":
            this.goToRouter("acctPwdInfoNode");
            break;
          case "权限资料":
            this.goToRouter("permInfoNode");
            break;
          case "评级授信":
            this.goToRouter("creditRatingNode");
            break;
          case "征信资料":
            this.goToRouter("creditInvestNode");
            break;
          case "业务确认":
            this.goToRouter("bizConfirm");
            break;
          case "信息录入":
            this.goToRouter("orgPartner");
            break;
          case "影像上传":
            this.goToRouter("imageUploadNode");
            break;
          case "知识测评":
            this.goToRouter("evaluatingNode");
            break;
          case "上传表单":
            this.goToRouter("formUploadNode");
            break;
          case "见证双录":
            this.goToRouter("videoWitnessInfoNode");
            break;                      
          case "表单打印":
            this.goToRouter("formPrintNode");
            break;
          case "开户信息":
            this.goToRouter("openAcctInfoNode");
            break;
          case "适当性信息":
            this.goToRouter("custMatchResultNode");
            break;
          default:
            break;
        }
      }
    },
    goToRouter (rouName) {
      // 校验是否可以跳转路由的方法
      if (!this.validateNext(rouName)) {
        return;
      }
      let index = _.findIndex(this.bizRouteTable, (item) => {
        return item.show && item.path.indexOf(rouName) > -1;
      });
      //更新下本地缓存的NODE_CODE,更新左侧导航栏的元素禁用属性，再进行跳转
      let oldBizData = this.$store.state.oldBizData;
      this.$store.commit(this.$types.UPDATE_OLD_BIZ_DATA, Object.assign({},oldBizData,{
        NODE_CODE: index
      }));
      this.$router.goRoute(index);
    },
    validateNext (rouName) {
      if (["QS420","QS421"].includes(this.busiCode)) {
        if (rouName == "imageUploadNode") {
          let BANK_ACCT_INFO_LIST = _.get(this.busiInfo, "BIZ_DATA.BANK_ACCT_INFO_LIST", []);
          if (_.isEmpty(BANK_ACCT_INFO_LIST)) {
            alert("请先完成资料录入再上传影像");
            return false;
          }
        } else if (rouName == "videoWitnessInfoNode" || rouName == "formUploadNode") {
          let pwdInfo = _.get(this.busiInfo, "BIZ_DATA.ACCT_PWD_INFO", []);
          // if (!pwdInfo.CUACCT_PWD) {
          //   alert(rouName == "videoWitnessInfoNode" ? "请点击下一步按钮，保存密码后再进行见证双录" : "请点击下一步按钮，保存密码后再上传表单");
          //   return false;
          // }
        }
      }
      return true;
    },
    getNavItem (route){
      if(!route){
        //历史节点为空，默认返回第一个
        return this.navRouteTable[0];
      }
      let nodeId = route.path.split("/")[4];
      if(nodeId && this.bizFlowStepsObj[nodeId] && route.show){
        return this.bizFlowStepsObj[nodeId];
      }
    },
    getDisabled (item) {
      //TODO TEST
      // return false;
      let isFinish = this.$syscfg.consts().FINISH_APPT_STATUS.includes(this.apptStatus);
      //兼容QS138 1S139 历史已完结的流水 随便跳转 或者是已完成状态的可以随便跳转
      if (["QS138","QS139"].includes(this.busiCode) || isFinish) {
        return false;
      }
      let nodeCode = _.get(this, "oldBizData.NODE_CODE");
      let nodeTitle = this.getNavItem(this.$store.state.bizRouteTable[nodeCode]);
      //历史节点
      let oldIndex = _.findIndex(this.navRouteTable, title=>title===nodeTitle) || 0;
      //目标节点
      let currentIndex = _.findIndex(this.navRouteTable, title=>title===item.title);
      //大于历史节点的都需要禁用
      if(currentIndex > oldIndex){
        return true;
      }else{
        return false;
      }

      // if (["QS420","QS421"].includes(this.busiCode)) { 
      //   if (item.title == "资料录入" || item.title == "影像上传") {
      //     return false;
      //   }
      //   if (this.apptStatus <= 3) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // } else {
      //   return false;
      // }
    }
  },
};
</script>

<style lang="less" scoped>
.kmos-step {
  margin-right: 15px;
  background: #fff;
  /deep/.el-steps.el-steps--vertical {
      justify-content: flex-start;
      .el-step.is-vertical {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 0;
          min-height: 80px;
          .el-step__head {
              // order: 5;
              // width: auto;
              // display: flex;
              // flex-direction: column;
              // align-items: center;
              display: none;
              .el-step__line {
                  display: none;
              }
              .el-step__icon {
                  width: 14px;
                  height: 18px;
                  margin: 9px 0 10px 0;
                  border-radius: 0;
                  border: none;
                  background: none;
                  // background-image: url('~@img/sider/sider1-1.png');
                  background-repeat: no-repeat;
                  background-position: center;
                  .el-step__icon-inner {
                      display: none;
                  }
              }
              
              &.is-success {
                  .el-step__icon{
                      // background-image: url('../../icons/red-theme/step/icon-step-arrow-done.svg');
                  }
              }
              &.is-process {
                  &::before,&::after {
                      position: absolute;
                      top: 0;
                      right: 0;
                      content: "";
                      display: block;
                      width: 10px;
                      height: 10px;
                      background: #fff;
                  }
                  &::before {
                      z-index: 1;
                      border-radius: 0  50% 0 0;
                  }
                  &+.el-step__main {
                      border-left: 1px solid;
                      border-left-color: #c59041;
                      color: #d0aa72;
                      background-image: -webkit-gradient(linear, left top, right top, from(#f3e4cf), to(#ffffff));
                      &::before,&::after {
                          // position: absolute;
                          // top: -10px;
                          // right: 0;
                          // content: "";
                          // display: block;
                          // width: 10px;
                          // height: 10px;
                          // background: #fff;
                      }
                      &::before {//选中
                          z-index: 1;
                          border-radius: 0  0 50% 0;
                          // background: #e53232;
                      }
                  }
              }
              &.is-wait {
                  color: #f19a9a;
              }
          }
          .el-step__head.is-success {
              color: #c52727;
              border: none;
          }
          .el-step__main {
              position: relative;
              display: flex;
              flex-direction: column;
              justify-content: center;
              padding-left: 0;
              border-radius: 3px 0 0 3px;
              flex-direction: row;
              align-items: center;
              .el-step__title {
                  display: flex;
                  min-height: 20px;
                  line-height: 1;
                  padding: 0px 5px 0 10px;
                  white-space: pre-wrap;
                  font-size: 18px;
                  text-align: center;
                  justify-content: center;
                  &.is-success {
                      color: #343434;
                      .el-step__icon-inner {
                          // color: #c52727;
                      }
                  }
                  &.is-process {
                      // color: #333;
                      font-weight: 600;
                      color: #d0aa72;
                  }
                  &.is-wait {
                      color: #343434;
                  }
              }
          }
          &:last-of-type .el-step__icon {
              opacity: 0;
              visibility: hidden;
          }
      }
      .el-step.disabled {
        .el-step__main {
          .el-step__title {
            &.is-wait {
              cursor: not-allowed;
              color: #999999
            }
          }
        }
      }
      .el-step.allowClick{
        cursor:pointer
      }
      // 导航图标
      .el-step__description {
          order: -5;
          display: inline-flex;
          justify-content: center;
          background: transparent;
          margin: 0;
          padding: 0;
          .step-icon {
              display: block;
              width: 16px;
              height: 16px;
              background-image: url('~@img/sider/sider1-1.png');
              background-repeat: no-repeat;
              background-size: cover;
              &.creditRatingNode, &.creditInvestNode {
                  width: 22px;
                  height: 20px;
              }
              &.orgPartner, &.bizInfoNode {
                  width: 19px;
                  height: 23px;
              }
              &.bizConfirm {
                  width: 20px;
                  height: 23px;
              }
              .step-icon {
                  &.baseInfoNode {background-image: url('~@img/sider/sider1-1.png');}
                  &.imageUploadNode{background-image: url('~@img/sider/sider2-1.png');}
                  &.formPrintNode{background-image: url('~@img/sider/sider3-1.png');}
                  &.videoWitnessInfoNode{background-image: url('~@img/sider/sider5-1.png');}
                  &.formUploadNode{background-image: url('~@img/sider/sider6-1.png');}
              }
          }
          
          &.is-process {
              .step-icon {
                  &.baseInfoNode {background-image: url('~@img/sider/sider1-2.png');}
                  &.imageUploadNode{background-image: url('~@img/sider/sider2-2.png');}
                  &.formPrintNode{background-image: url('~@img/sider/sider3-2.png');}
                  &.videoWitnessInfoNode{background-image: url('~@img/sider/sider5-2.png');}
                  &.formUploadNode{background-image: url('~@img/sider/sider6-2.png');}
                  // &.acctInfoNode { background-image: url('../../icons/red-theme/step/icon-step-account-doing.svg');}
                  // &.openAcctInfoNode { background-image: url('../../icons/red-theme/step/icon-step-account-doing.svg');}
                  // &.agentInfoNode { background-image: url('../../icons/red-theme/step/icon-step-account-doing.svg');}
                  // &.keyInfoNode { background-image: url('../../icons/red-theme/step/icon-step-permission-doing.svg');}
                  // &.normalInfoNode { background-image: url('../../icons/red-theme/step/icon-step-permission-doing.svg');}
                  // &.custVisitNode { background-image: url('../../icons/red-theme/step/icon-step-account-doing.svg');}
                  // &.videoWitnessInfoNode { background-image: url('../../icons/red-theme/step/icon-step-account-doing.svg');}
                  // &.formPrintNode { background-image: url('../../icons/red-theme/step/icon-step-account-doing.svg');}
                  // &.permInfoNode { background-image: url('../../icons/red-theme/step/icon-step-permission-doing.svg');}
                  // &.creditRatingNode { background-image: url('../../icons/red-theme/step/icon-step-credit-doing.svg');}
                  // &.creditInvestNode { background-image: url('../../icons/red-theme/step/icon-step-credit-doing.svg');}
                  // &.orgPartner { background-image: url('../../icons/red-theme/step/icon-step-edit-doing.svg');}
                  // &.bizInfoNode { background-image: url('../../icons/red-theme/step/icon-step-edit-doing.svg');}
                  // &.evaluatingNode { background-image: url('../../icons/red-theme/step/icon-step-test-doing.svg');}
                  // &.bizConfirm { background-image: url('../../icons/red-theme/step/icon-step-confirm-doing.svg');}
                  // &.imageCollectSupply { background-image: url('../../icons/red-theme/step/icon-step-image-doing.svg');}
                  // &.imageAcquisition { background-image: url('../../icons/red-theme/step/icon-step-image-doing.svg');}
                  // &.custMatchResultNode { background-image: url('../../icons/red-theme/step/icon-step-test-doing.svg');}

              }
          }
          // &.is-success {
          //     .step-icon {
          //         &.baseInfoNode {background-image: url('../../icons/red-theme/step/icon-step-files-done.svg');}
          //         &.acctInfoNode { background-image: url('../../icons/red-theme/step/icon-step-account-done.svg');}
          //         &.openAcctInfoNode { background-image: url('../../icons/red-theme/step/icon-step-account-done.svg');}
          //         &.agentInfoNode { background-image: url('../../icons/red-theme/step/icon-step-account-done.svg');}
          //         &.keyInfoNode { background-image: url('../../icons/red-theme/step/icon-step-permission-done.svg');}
          //         &.normalInfoNode { background-image: url('../../icons/red-theme/step/icon-step-permission-done.svg');}
          //         &.custVisitNode { background-image: url('../../icons/red-theme/step/icon-step-account-done.svg');}
          //         &.videoWitnessInfoNode { background-image: url('../../icons/red-theme/step/icon-step-account-done.svg');}
          //         &.formPrintNode { background-image: url('../../icons/red-theme/step/icon-step-account-done.svg');}
          //         &.permInfoNode { background-image: url('../../icons/red-theme/step/icon-step-permission-done.svg');}
          //         &.creditRatingNode { background-image: url('../../icons/red-theme/step/icon-step-credit-done.svg');}
          //         &.creditInvestNode { background-image: url('../../icons/red-theme/step/icon-step-credit-done.svg');}
          //         &.orgPartner { background-image: url('../../icons/red-theme/step/icon-step-edit-done.svg');}
          //         &.bizInfoNode { background-image: url('../../icons/red-theme/step/icon-step-edit-done.svg');}
          //         &.evaluatingNode { background-image: url('../../icons/red-theme/step/icon-step-test-done.svg');}
          //         &.bizConfirm { background-image: url('../../icons/red-theme/step/icon-step-confirm-done.svg');}
          //         &.imageCollectSupply { background-image: url('../../icons/red-theme/step/icon-step-image-done.svg');}
          //         &.imageAcquisition { background-image: url('../../icons/red-theme/step/icon-step-image-done.svg');}      
          //         &.custMatchResultNode { background-image: url('../../icons/red-theme/step/icon-step-test-done.svg');}
          //     }
          // }
          // &.is-wait {
          //     .step-icon {
          //         &.baseInfoNode {background-image: url('../../icons/red-theme/step/icon-step-files-waitting.svg');}
          //         &.acctInfoNode { background-image: url('../../icons/red-theme/step/icon-step-account-waitting.svg');}
          //         &.openAcctInfoNode { background-image: url('../../icons/red-theme/step/icon-step-account-waitting.svg');}
          //         &.agentInfoNode { background-image: url('../../icons/red-theme/step/icon-step-account-waitting.svg');}
          //         &.keyInfoNode { background-image: url('../../icons/red-theme/step/icon-step-permission-waitting.svg');}
          //         &.normalInfoNode { background-image: url('../../icons/red-theme/step/icon-step-permission-waitting.svg');}
          //         &.custVisitNode { background-image: url('../../icons/red-theme/step/icon-step-account-waitting.svg');}
          //         &.videoWitnessInfoNode { background-image: url('../../icons/red-theme/step/icon-step-account-waitting.svg');}
          //         &.formPrintNode { background-image: url('../../icons/red-theme/step/icon-step-account-waitting.svg');}
          //         &.permInfoNode { background-image: url('../../icons/red-theme/step/icon-step-permission-waitting.svg');}
          //         &.creditRatingNode { background-image: url('../../icons/red-theme/step/icon-step-credit-waitting.svg');}
          //         &.creditInvestNode { background-image: url('../../icons/red-theme/step/icon-step-credit-waitting.svg');}
          //         &.orgPartner { background-image: url('../../icons/red-theme/step/icon-step-edit-waitting.svg');}
          //         &.bizInfoNode { background-image: url('../../icons/red-theme/step/icon-step-edit-waitting.svg');}
          //         &.evaluatingNode { background-image: url('../../icons/red-theme/step/icon-step-test-waitting.svg');}
          //         &.bizConfirm { background-image: url('../../icons/red-theme/step/icon-step-confirm-waitting.svg');}
          //         &.imageCollectSupply { background-image: url('../../icons/red-theme/step/icon-step-image-waitting.svg');}
          //         &.imageAcquisition { background-image: url('../../icons/red-theme/step/icon-step-image-waitting.svg');}                   
          //         &.custMatchResultNode { background-image: url('../../icons/red-theme/step/icon-step-test-waitting.svg');}
          //     }
          // }
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/navStep.vue